var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5661 5.51L15.5161 3.07C14.8561 2.54 14.0261 2.25 13.1761 2.25H8.22607C6.15607 2.25 4.47607 3.93 4.47607 6V18C4.47607 20.07 6.15607 21.75 8.22607 21.75H16.2261C18.2961 21.75 19.9761 20.07 19.9761 18V8.44C19.9761 7.29 19.4661 6.23 18.5661 5.51ZM17.6261 6.68C17.8261 6.84 17.9861 7.04 18.1161 7.24H14.2261C14.0861 7.24 13.9761 7.13 13.9761 6.99V3.99C13.9761 3.99 13.9561 3.92 13.9561 3.88C14.1761 3.96 14.3961 4.08 14.5761 4.23L17.6261 6.67V6.68ZM16.2161 20.24H8.22607C6.98607 20.24 5.97607 19.23 5.97607 17.99V6C5.97607 4.76 6.98607 3.75 8.22607 3.75H12.5261C12.4961 3.83 12.4761 3.91 12.4761 4V7C12.4761 7.96 13.2661 8.75 14.2261 8.75H18.2261C18.3161 8.75 18.3961 8.73 18.4761 8.7V18C18.4761 19.24 17.4661 20.25 16.2261 20.25L16.2161 20.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.aad810aeb1134ed3ee082c249181dbc2.svg";
export { ForwardRef as ReactComponent };